const testimonialData = [
  {
    id: 1,
    name: "Mr. Jilani Chini",
    position: "CEO",
    company: "House of Ice-Cream",
    handle: "https://www.instagram.com/house_of_ice_cream_",
    testimonial: 
      "The team delivered a customized billing software that simplified our operations and also managed our marketing campaigns with great impact. Their end-to-end support has been invaluable for House of Ice-Cream.",
    image: "images/testimonial/house-of-ice-cream.jpeg"
  },
  {
    id: 2,
    name: "Mr. Anas Ali",
    position: "CFO",
    company: "ForMeds",
    handle: "https://formeds.in",
    testimonial:
      "From prototype to a fully scalable product, the team has been instrumental in bringing Formeds to life. Their technical expertise and commitment made our startup journey seamless and impactful.",
    image: "images/testimonial/formeds.jpeg"
  },
  {
    id: 3,
    name: "Mr. Aslam",
    position: "CEO",
    company: "Welcome IceCream",
    handle: "https://www.instagram.com/wellcome_ice_cream",
    testimonial:
      "The customized Billing and Management Software has transformed how we manage our operations at Welcome IceCream. It’s seamless, efficient, and perfectly tailored to our needs. A truly reliable solution!",
    image: "images/testimonial/welcome-icecream.jpeg"
  },
  // {
  //   id: 4,
  //   name: "Daniel Ortiz",
  //   position: "Founder & CEO",
  //   company: "Finova",
  //   testimonial:
  //     "They helped us validate a new revenue stream and shipped an MVP in 8 weeks. Advisors and investors were impressed with the execution.",
  //   videoUrl: "https://www.youtube.com/watch?v=ysz5S6PUM-U"
  // },
  // {
  //   id: 5,
  //   name: "Olivia Park",
  //   position: "Lead Designer",
  //   company: "Blueframe",
  //   handle: "@blueframe",
  //   testimonial:
  //     "Design-led development changed how our teams collaborate. Their design system saved us hundreds of hours across releases.",
  //   image: "/logos/meta.png"
  // },
  // {
  //   id: 6,
  //   name: "Ethan Walker",
  //   position: "Growth Lead",
  //   company: "RetailUp",
  //   testimonial:
  //     "A data-driven growth plan produced a consistent 22% month-over-month uplift — the playbooks they created are reusable across channels.",
  //   videoUrl: "/background/videos/HeroVideo.mp4"
  // }
];

module.exports = { testimonialData };
